<template>
  <div class="page-proposal">
    <NavBar active-menu="proposal"></NavBar>
    <SearchProposal></SearchProposal>
  </div>
</template>

<script>
import NavBar from '../components/NavBar.vue';
import SearchProposal from '../components/SearchProposal.vue';
export default {
  components: {
    NavBar,
    SearchProposal,
  },
};
</script>
